export default class ColourPalette {
  static colours = {
    Red: '#E63946',
    Brown: '#8A3A00',
    Toffee: '#B17446',
    Orange: '#F3722C',
    Yellow: '#F3B100',
    Lime: '#84C11A',
    Green: '#35993A',
    Teal: '#00A6A6',
    Cyan: '#00B4D8',
    Azure: '#0077B6',
    Blue: '#4361EE',
    Indigo: '#7F63D2',
    Purple: '#7B2CBF',
    Cerise: '#D0006F',
    Pink: '#FB4E88',
    Black: '#000000',
  }

  static fromName(colour) {
    return this.colours[colour]
  }

  static nameOf(hex) {
    return Object.keys(this.colours).find(
      colour => this.colours[colour].toUpperCase() === `${hex}`.toUpperCase()
    )
  }

  static getColours() {
    return Object.entries(this.colours).map(color => {
      return color[1]
    })
  }
}
